import React from "react";
import "../styles/About.css";
import Foodtray from '../assets/top-view-delicious-fish-meal-tray.jpg'

function About() {
  return (
    <div className="about">
      <div
        className="aboutTop"
        style={{ backgroundImage: `url(${Foodtray})` }}
      ></div>
      <div className="aboutBottom">
        <h1> ABOUT US</h1>
        <p>
        Established in 2024 by a close-knit group of friends who shared a deep passion for bold and enticing flavors, Ceylon Spice is more than just a restaurant – it's a culinary dream realized. Born after completing our university degrees, we set out on a mission to bring the richness of spicy and delectable cuisine to our community. Our menu reflects our commitment to quality, as each dish is carefully crafted to deliver a memorable experience. At Ceylon Spice, we believe in the power of spices to transform a meal into an adventure, and our chefs bring their expertise to every plate. Join us in this flavorful journey, where our love for spice and a dedication to exceptional dining converge. Come savor the taste of friendship and the zest of our meticulously prepared dishes at Ceylon Spice.
        </p>
      </div>
    </div>
  );
}

export default About;
